import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import LoyaltyGuestLandingPage from './loyaltyGuestPage/LoyaltyGuestLandingPage'
import LoyaltyUserLandingPage from './loyaltyUserPage/LoyaltyUserLandingPage'
import LoyaltyAccountLandingPage from './loyaltyUserAccountPage/LoyaltyAccountLandingPage'
import useEsimHashModal from 'loyalty/hooks/useEsimHashModal'
import useLoyaltyBenefitHashModals from 'loyalty/hooks/useLoyaltyBenefitHashModals'

function LoyaltyLandingPageContainer() {
  const loggedIn = useAppSelector(selectLoggedIn)
  const loyaltyAccount = useAppSelector(state => state.loyalty.account.data)
  useEsimHashModal()
  useLoyaltyBenefitHashModals()

  if (loggedIn) {
    if (loyaltyAccount) {
      return <LoyaltyAccountLandingPage />
    }
    return <LoyaltyUserLandingPage />
  }
  return <LoyaltyGuestLandingPage />
}

export default LoyaltyLandingPageContainer
